import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import logoImage from "../assets/COT_logo-removebg-preview.png";
import { red } from "@mui/material/colors";
import { useLocation } from "react-router-dom";

function SalarySlip() {

 const location = useLocation();
     const { pays, DirCut, conversion } = location.state || {};
const totalMargin = pays?.reduce(
  (sum, item) => sum + item.totalMargin,
  0
);

const totalAgentPay = pays?.reduce(
  (sum, item) => sum + item.agentPay,
  0
);

const totalDirectorCut = pays?.reduce(
  (sum, item) => sum + item.directorCut,
  0
);

const toCamelCase = (str = "") => {
  return str
    .trim()
    .replace(/[_\-\s]+(.)?/g, (_, c) => c ? c.toUpperCase() : "")
};

    const MyDocument = ({
        salaryList,
        directorCut,
        conversion
}) => {

      return (
        <Document>
          <Page size="A4" style={styles.page} wrap>
             <Image src={logoImage} style={styles.logo} />
             <View style={styles.inner}>
                    <View style={styles.titleHolder}>
                        <Text style={styles.title}>Employee Salary Summery </Text>
                    </View>

                    <View style={styles.table}>

  {/* TABLE HEADER */}
  <View style={[styles.tableRow, styles.tableHeader]}>
    <Text style={[styles.cell, styles.agent, styles.headerText]}>Agent</Text>
    <Text style={[styles.cell, styles.percent, styles.headerText]}>%</Text>
    <Text style={[styles.cell, styles.margin, styles.headerText]}>Margin</Text>
    <Text style={[styles.cell, styles.pay, styles.headerText]}>Agent Pay</Text>
    <Text style={[styles.cell, styles.percent,  styles.margin]}>Agent Pay PKR</Text>
    <Text style={[styles.cell, styles.director, styles.headerText]}>
      Director Cut
    </Text>
  </View>

  {/* TABLE BODY */}
  {salaryList?.map((item, index) => (
    <View key={index} style={styles.tableRow}>
      <Text style={[styles.cell, styles.agent]}>{toCamelCase(item.agent)}</Text>
      <Text style={[styles.cell, styles.percent]}>{item.percentage}%</Text>
      <Text style={[styles.cell, styles.margin]}>
        {item.totalMargin.toFixed(2)}
      </Text>
      <Text style={[styles.cell, styles.pay]}>
        {item.agentPay.toFixed(2)}
      </Text>
      <Text style={[styles.cell, styles.margin]}>PKR {(item.agentPay.toFixed(2)*375).toFixed(2)}</Text>
      <Text style={[styles.cell, styles.director]}>
        {item.directorCut.toFixed(2)}
      </Text>
    </View>
  ))}
  {/* TOTAL ROW */}
<View style={styles.tableRow}>
  {/* <Text
    style={[
      styles.cell,
      styles.agent,
      { fontWeight: "bold" },
    ]}
  >
    TOTAL
  </Text> */}


  {/* <Text style={[styles.cell, styles.percent]} /> */}

  <Text
    style={[
      styles.cell,
      styles.margin,
      { fontWeight: "bold" },
    ]}
  >
    {totalMargin.toFixed(2)}
  </Text>

  <Text
    style={[
      styles.cell,
      styles.pay,
      { fontWeight: "bold" },
    ]}
  >
    {totalAgentPay.toFixed(2)}
  </Text>

  <Text
    style={[
      styles.cell,
      styles.director,
      { fontWeight: "bold" },
    ]}
  >
    {totalDirectorCut.toFixed(2)}
  </Text>
  
</View>

</View>

             </View>
          </Page>
        </Document>
      )
          
}

  return (
    <div>
      <h1>PDF Preview</h1>
      <PDFViewer width="100%" height="2000px" >
        <MyDocument
         salaryList={pays}
         directorCut={DirCut}
         conversion ={conversion}
        />
      </PDFViewer>
    </div>
  );
}

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "white",
    padding: 40,
  },
  logo:{
    height:60,
    width:110,
  },

  plaintext:{
    fontSize:11,
  },
  title:{
    textAlign:"center",
    fontSize:20
  },

  inner:{
    marginTop:20
  },
   table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    marginTop: 10,
  },

  tableRow: {
    flexDirection: "row",
  },

  tableHeader: {
    backgroundColor: "#f0f0f0",
  },

  cell: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    padding: 6,
    fontSize: 10,
  },

  agent: { width: "20%" },
  percent: { width: "10%" },
  margin: { width: "20%" },
  pay: { width: "25%" },
  director: { width: "25%" },

  headerText: {
    fontWeight: "bold",
  },



  
});
export default SalarySlip;